/**
 * Creates a minimal mock geolocation object
 * @returns A simple object implementing the Geolocation interface
 */
const createMockGeolocation = (): Geolocation => {
  // Create a basic mock position with fixed coordinates (Paris)
  const mockPosition = {
    coords: {
      latitude: 48.8566,
      longitude: 2.3522,
      accuracy: 50,
      altitude: null,
      altitudeAccuracy: null,
      heading: null,
      speed: null
    } as GeolocationCoordinates,
    timestamp: Date.now(),
    toJSON: () => JSON.stringify(mockPosition)
  } as GeolocationPosition;

  // Return the simplest possible implementation of Geolocation interface
  return {
    getCurrentPosition(successCallback) {
      setTimeout(() => successCallback(mockPosition), 0);
    },
    watchPosition(successCallback) {
      setTimeout(() => successCallback(mockPosition), 0);
      return 1;
    },
    clearWatch() {}
  };
};

export const mockGeolocation = createMockGeolocation();
